import React from "react";
import { Box, Typography } from "@material-ui/core";

interface ChargeProps {
  name: string;
  price: string | null;
}

// Markup for a single charge line in Agreement Details
export const Charge: React.FC<ChargeProps & { "data-testid"?: string }> = ({
  name,
  price,
  ...props
}) => {
  return (
    <Box display="flex" height={50} alignItems="center" {...props}>
      <Box width={0.6} mr={2}>
        <Typography variant="body1">{name}</Typography>
      </Box>
      <Box width={0.4} pr={2} textAlign="right">
        <Typography variant="body1">{price || "-"} </Typography>
      </Box>
    </Box>
  );
};
